module.exports = {
    PAYMENT_TYPE: Object.freeze({
        PRE_PAYMENT: 1,
        POST_PAYMENT: 2,
        PRE_POST_PAYMENT: 3,
    }),
};
